import { render, staticRenderFns } from "./StructureViewerMotif.vue?vue&type=template&id=db1243a2&scoped=true"
import script from "./StructureViewerMotif.vue?vue&type=script&lang=js"
export * from "./StructureViewerMotif.vue?vue&type=script&lang=js"
import style0 from "./StructureViewerMotif.vue?vue&type=style&index=0&id=db1243a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1243a2",
  null
  
)

export default component.exports